module.exports = __webpack_public_path__ + "static/media/ruler.72c46274.svg";